export const stateRegions = [
    {        
        name: 'Lewis Warrington, MD',
        email: 'lewis@ironshorepharma.com',
        phone: '(984) 224-5021',
        isDefault: true,
        states: [
            'Idaho',
            'Maine',
            'Montana',
            'New Jersey',
            'New Mexico',
            'South Dakota',
            'Wyoming',
        ]
    },
    {
        name: 'Ryan Gregg, PhD',
        email: 'ryan.gregg@ironshorepharma.com',
        phone: '(984) 232-2979',
        states: [
            'Connecticut',
            'Delaware',
            'Maryland',
            'Massachusetts',
            'New Hampshire',
            'New York',
            'North Carolina',
            'Ohio',
            'Pennsylvania',
            'Rhode Island',
            'Tennessee',
            'Vermont',
            'Virginia',
            'Washington, D.C.',
            'District of Columbia',
            'West Virginia',
        ]
    },
    {
        name: 'Justin Barnes, PhD',
        email: 'justin@ironshorepharma.com',
        phone: '(984) 232-2975',
        states: [
            'Alaska',
            'Colorado',
            'Illinois',
            'Indiana',
            'Iowa',
            'Kansas',
            'Kentucky',
            'Michigan',
            'Minnesota',
            'Missouri',
            'Nebraska',
            'Nevada',
            'North Dakota',
            'California',
            'Oregon',
            'Utah',
            'Washington',
            'Wisconsin',
        ]
    },
    {
        name: 'Karl Weddige, PhD',
        email: 'karl.weddige@ironshorepharma.com',
        phone: '(984) 232-2976',        
        states: [
            'Alabama',
            'Arizona',
            'Arkansas',
            'Florida',
            'Georgia',
            'Hawaii',
            'Louisiana',
            'Mississippi',
            'Oklahoma',
            'South Carolina',
            'Texas',
        ]
    }
]